import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';

import ComponentMainNav from "../../components/ComponentMainNav/ComponentMainNav";
import ComponentCartBig from "../../components/ComponentCartBig/ComponentCartBig";

import styles from './ComponentHeaderPublic.scss';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";

import PromoBanner from './PromoBanner'


class ComponentHeaderPublic extends BaseComponent {

	constructor(props) {
		super(props);
		const promoBarVisibleDefault = false;

		const promoBarVisible = (props.promoBarVisible === false) ? false : promoBarVisibleDefault;
		this.promoBarVisible = promoBarVisible;

		if (promoBarVisible !== true) {
			document.body.classList.add(styles.bodyNormal);
		}
	}

	render() {
		return (
			<div className={styles.header}>
				{this.promoBarVisible === true ?
					<PromoBanner/>
					: null
				}
				<ComponentMainNav data={{}} promoBarVisible={this.promoBarVisible}/>
				<ComponentCartBig data={{}} promoBarVisible={this.promoBarVisible}/>
			</div>
		)
	}
}


// React Context binding
ComponentHeaderPublic.contextType = ContextDataStore;

export default ComponentHeaderPublic;